/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Templatedescription1Inputs */

const en_entity_templatedescription1 = /** @type {(inputs: Entity_Templatedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template Description`)
};

const de_entity_templatedescription1 = /** @type {(inputs: Entity_Templatedescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Template-Beschreibung`)
};

/**
* | output |
* | --- |
* | "Template Description" |
*
* @param {Entity_Templatedescription1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_templatedescription1 = /** @type {((inputs?: Entity_Templatedescription1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Templatedescription1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_templatedescription1(inputs)
	return de_entity_templatedescription1(inputs)
});
export { entity_templatedescription1 as "entity_templateDescription" }